import get from 'lodash/get';
import has from 'lodash/has';
import translation from '@lang/index';
import {ObjectLength} from "../helpers/arrays";
import {isEmpty, str_replace} from "../helpers/helpers";

/*
*@param path
**/
function useTrans(path, attributes = {}) {
    const keys = path.split(".");

    if (has(translation, keys[0]) && has(translation[keys[0]], keys[1])) {
        let text = '';

        if (!isEmpty(keys[2])) {
            text = get(get(translation[keys[0]], keys[1]), keys[2]);
        } else {
            text = get(translation[keys[0]], keys[1]);
        }

        if (ObjectLength(attributes)) {
            Object.keys(attributes).forEach(key => {
                const attribute = attributes[key];
                text = str_replace(':' + key, attribute, text);
            })
        }

        return text;
    }
    return path;
}

export default useTrans;

// example => useTrans('property.info')